import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated } from '../auth';
import LoginView from '../views/LoginView.vue';
import SpareComponents from '../views/SpareComponents.vue';
import RequestBuilder from '../views/RequestBuilder.vue';
import SupplierManagement from '../views/SupplierManagement.vue';
import RequestArchives from '../views/RequestArchives.vue';

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: LoginView,
		meta: { guestOnly: true }
	},
	{
		path: '/',
		redirect: '/spare-components'
	},
	{
		path: '/spare-components',
		name: 'SpareComponents',
		component: SpareComponents,
		meta: { requiresAuth: true }
	},
	{
		path: '/request-builder/:id?',
		name: 'RequestBuilder',
		component: RequestBuilder,
		props: true,
		meta: { requiresAuth: true }
	},
	{
		path: '/suppliers',
		name: 'SupplierManagement',
		component: SupplierManagement,
		meta: { requiresAuth: true }
	},
	{
		path: '/request-archives',
		name: 'RequestArchives',
		component: RequestArchives,
		meta: { requiresAuth: true }
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

router.beforeEach((to) => {
	const authenticated = isAuthenticated();

	if (to.meta.requiresAuth && !authenticated) {
		return {
			path: '/login',
			query: {
				redirect: to.fullPath
			}
		};
	}

	if (to.meta.guestOnly && authenticated) {
		return '/spare-components';
	}

	return true;
});

export default router;

